import { RootState } from 'modules'

import { AdsType } from './duck'

export const selectAds = (state: RootState): AdsType | null => state.ads
